import { createDomain, sample } from 'effector'
import { viewerModel } from '~/entities/common/viewer'
import { AxiosErrorType, User } from '~/shared/api'
import { replaceFx } from '~/shared/lib/history'
import { i18nModel } from '~/shared/lib/i18n'
import { logger } from '~/shared/lib/logger'
import { mapMessageErrors } from '~/shared/lib/mapMessageErrors'
import { snackbarEnqueued } from '~/shared/lib/notifications'
import { FormValues } from './lib'

export const domain = createDomain('features.auth.by-credentials.login')

export const loginFx = domain.createEffect<
  FormValues,
  { token: string },
  AxiosErrorType
>({
  async handler(credentials) {
    return User.login(credentials)
  },
})

export const getUserMeFx = domain.createEffect({
  async handler() {
    return User.me()
  },
})

sample({
  clock: loginFx.doneData,
  fn({ token }) {
    return token
  },
  target: viewerModel.tokenSaved,
})

sample({
  clock: viewerModel.tokenSaved,
  target: getUserMeFx,
})

sample({
  clock: getUserMeFx.doneData,
  target: [viewerModel.userOptionsSave, i18nModel.localeChangeFx],
})

sample({
  clock: loginFx.failData,
  fn(e) {
    logger.error(e)
    return {
      message: mapMessageErrors(e),
      variant: 'error' as const,
    }
  },
  target: snackbarEnqueued,
})

/* Submitted */
export const formSubmitted = domain.createEvent<FormValues>()
sample({
  clock: formSubmitted,
  target: loginFx,
})

sample({
  clock: getUserMeFx.doneData,
  fn() {
    return '/'
  },
  target: replaceFx,
})

sample({
  clock: getUserMeFx.failData,
  fn(e) {
    logger.error(e)
    return {
      messageI18n: 'alert.failed to load user settings' as const,
      variant: 'warning' as const,
    }
  },
  target: snackbarEnqueued,
})
